import { render, staticRenderFns } from "./MaterialRecord.vue?vue&type=template&id=23cdaeb2&scoped=true"
import script from "./MaterialRecord.vue?vue&type=script&lang=js"
export * from "./MaterialRecord.vue?vue&type=script&lang=js"
import style0 from "./MaterialRecord.vue?vue&type=style&index=0&id=23cdaeb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cdaeb2",
  null
  
)

export default component.exports